import $ from 'jquery';
function options() {
  let scrollTop = $(window).scrollTop(),
    lastScrollTop = scrollTop;

  var mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)');

  if (mobile.matches) {
    $('header').addClass('header--scrolled');
  } else if (scrollTop > 800) {
    $('header').addClass('header--scrolled');
  }

  if (scrollTop <= 0) {
    $('header').removeClass('hiden header--scrolled');
  }

  function throttle(fn, wait) {
    var time = Date.now();
    return function () {
      if (time + wait - Date.now() < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  window.addEventListener('scroll', throttle(DocumentScroll, 100));

  function DocumentScroll() {
    scrollTop = $(window).scrollTop();

    if ($('header')) {
      if (scrollTop < lastScrollTop) {
        // scroll UP
        $('header').removeClass('header--hide');
      } else {
        // scroll DOWN
        if (scrollTop > $('header').height()) {
          $('header').addClass('header--hide');
        }
      }
    }

    if (mobile.matches) {
      scrollTop > 200
        ? $('header').addClass('header--scrolled')
        : $('header').removeClass('header--scrolled');
    } else {
      scrollTop > 800
        ? $('header').addClass('header--scrolled')
        : $('header').removeClass('header--scrolled');
    }

    lastScrollTop = scrollTop;
  }
}
export default options;
